import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

function Navbar() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Check if a link is active
  const isActive = (path) => {
    return location.pathname === path ? "text-teal-400" : "text-white";
  };

  // Check if a hash link is active (for home page sections)
  const isHashActive = (hash) => {
    return location.pathname === "/" && location.hash === hash
      ? "text-teal-400"
      : "text-white";
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-30 bg-[#060606] bg-opacity-90 shadow">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center space-x-4">
          <Link to="/">
            <img src="/GABS-Logo-2.png" alt="Logo" className="w-120 h-10" />
          </Link>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-6">
          <Link
            to="/"
            className={`${isActive("/")} hover:text-teal-400 transition-colors`}
          >
            Home
          </Link>
          <a
            href="#categories"
            className={`${isHashActive("#categories")} hover:text-teal-400 transition-colors`}
          >
            Kategorien
          </a>
          <Link
            to="/contact"
            className={`${isActive("/contact")} hover:text-teal-400 transition-colors`}
          >
            Kontakt
          </Link>
          <Link
            to="/aboutus"
            className={`${isActive("/aboutus")} hover:text-teal-400 transition-colors`}
          >
            Über uns
          </Link>
          <Link
            to="/datenschutz"
            className={`${isActive("/datenschutz")} hover:text-teal-400 transition-colors`}
          >
            Datenschutzerklärung
          </Link>
          <Link
            to="/impressum"
            className={`${isActive("/impressum")} hover:text-teal-400 transition-colors`}
          >
            Impressum
          </Link>
          <Link
            to="/Haftungsausschluss"
            className={`${isActive("/Haftungsausschluss")} hover:text-teal-400 transition-colors`}
          >
            Haftungsausschluss
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden focus:outline-none text-white"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {/* Hamburger Icon */}
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>

      {/* Mobile Menu (collapsible) */}
      {isMenuOpen && (
        <div className="md:hidden bg-[#060606] px-4 pb-4 space-y-2">
          <Link
            to="/"
            className={`block ${isActive("/")} hover:text-teal-400 transition-colors`}
            onClick={() => setIsMenuOpen(false)}
          >
            Home
          </Link>
          <a
            href="#categories"
            className={`block ${isHashActive("#categories")} hover:text-teal-400 transition-colors`}
            onClick={() => setIsMenuOpen(false)}
          >
            Kategorien
          </a>
          <Link
            to="/contact"
            className={`block ${isActive("/contact")} hover:text-teal-400 transition-colors`}
            onClick={() => setIsMenuOpen(false)}
          >
            Kontakt
          </Link>
          <Link
            to="/aboutus"
            className={`block ${isActive("/aboutus")} hover:text-teal-400 transition-colors`}
            onClick={() => setIsMenuOpen(false)}
          >
            Über uns
          </Link>
          <Link
            to="/datenschutz"
            className={`block ${isActive("/datenschutz")} hover:text-teal-400 transition-colors`}
            onClick={() => setIsMenuOpen(false)}
          >
            Datenschutzerklärung
          </Link>
          <Link
            to="/impressum"
            className={`block ${isActive("/impressum")} hover:text-teal-400 transition-colors`}
            onClick={() => setIsMenuOpen(false)}
          >
            Impressum
          </Link>
          <Link
            to="/Haftungsausschluss"
            className={`block ${isActive("/Haftungsausschluss")} hover:text-teal-400 transition-colors`}
            onClick={() => setIsMenuOpen(false)}
          >
            Haftungsausschluss
          </Link>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
